import { DeleteParams, DeleteResult, GetOneParams, GetOneResult, UpdateParams, UpdateResult } from 'react-admin';
import { getClientApi } from 'src/data-communication';
import {
  BaseAccountApplicationDocumentParamsDto,
  BaseAccountApplicationParamsDto,
  UpdateAccountApplicationBodyDto,
} from 'src/dtos';
import { mapAccountApplicationDtoToModel, mapAcountApplicationDocumentDtoToModel } from 'src/mappers';
import { AccountApplication, AccountApplicationDocument, DownloadFileResponse } from 'src/models';

const clientApi = getClientApi();

export const getAccountApplication = async (
  params: GetOneParams<BaseAccountApplicationParamsDto>,
): Promise<GetOneResult<AccountApplication>> => {
  const response = await clientApi.accountApplication.retrieve({
    params: {
      id: params.id.toString(),
      accountId: params.meta.accountId.toString(),
    },
  });

  return {
    data: mapAccountApplicationDtoToModel(response),
  };
};

export const updateAccountApplication = async (
  params: UpdateParams<UpdateAccountApplicationBodyDto & { id: string }>,
): Promise<UpdateResult<AccountApplication>> => {
  const response = await clientApi.accountApplication.update({
    params: {
      id: params.id.toString(),
      accountId: params.meta.accountId.toString(),
    },
    body: {
      categories: params.data?.categories || [],
    },
  });

  return {
    data: mapAccountApplicationDtoToModel(response),
  };
};

export const uploadAccountApplicationDocument = async (
  params: UpdateParams<FormData & { id: string }>,
): Promise<UpdateResult<AccountApplicationDocument>> => {
  const response = await clientApi.accountApplication.uploadDocument({
    params: {
      id: params.id,
      accountId: params.meta.accountId.toString(),
    },
    body: params.data as any,
    onProgress: params.meta.onProgress,
  });

  return {
    data: mapAcountApplicationDocumentDtoToModel(response),
  };
};

export const downloadAccountApplicationDocument = async (
  params: GetOneParams<BaseAccountApplicationDocumentParamsDto>,
): Promise<GetOneResult<DownloadFileResponse>> => {
  const { id, meta } = params;
  const file = await clientApi.accountApplication.downloadDocument({
    params: {
      id: id.toString(),
      accountId: meta.accountId.toString(),
      documentId: meta.documentId.toString(),
    },
  });

  const fileUrl = URL.createObjectURL(file);

  return {
    data: { id: params.id, file: { url: fileUrl, type: meta.type, name: meta.name } },
  };
};

export const updateAccountApplicationDocument = async (
  params: UpdateParams<FormData & { id: string }>,
): Promise<UpdateResult<AccountApplicationDocument>> => {
  const response = await clientApi.accountApplication.updateDocument({
    params: {
      id: params.id,
      accountId: params.meta.accountId.toString(),
      documentId: params.meta.documentId.toString(),
    },
    body: params.data as any,
    onProgress: params.meta.onProgress,
  });

  return {
    data: mapAcountApplicationDocumentDtoToModel(response),
  };
};

export const deleteAccountApplicationDocument = async (
  params: DeleteParams<BaseAccountApplicationDocumentParamsDto>,
): Promise<DeleteResult<{ id: string }>> => {
  await clientApi.accountApplication.deleteDocument({
    params: {
      id: params.id.toString(),
      accountId: params.meta.accountId.toString(),
      documentId: params.meta.documentId.toString(),
    },
  });

  return {
    data: { id: params.id.toString() },
  };
};
